// Helpers for deriving CS2 connect strings from a server's host + port.
// CS2 has no SRV support, so the port selects the server. The port is always
// included in the connect string — even the default (27015) — so the command
// is unambiguous.

export const DEFAULT_PORT = 27015;

const hostWithPort = (host, port) => {
  const h = (host || '').trim();
  const p = Number(port) || DEFAULT_PORT;
  return `${h}:${p}`;
};

export const buildConnectCommand = (host, port) => `connect ${hostWithPort(host, port)}`;

export const buildSteamLink = (host, port) => `steam://connect/${hostWithPort(host, port)}`;
